/**
 * Utilidades para formatear datos
 */

/**
 * Formatea un número como precio con separadores de miles
 * @param {number|string|null|undefined} precio - Precio a formatear
 * @param {string} fallback - Valor a mostrar si el precio es inválido (default: '-')
 * @returns {string} Precio formateado
 */
export const formatPrecio = (precio, fallback = '-') => {
  if (precio == null || precio === '') return fallback;
  const num = Number(precio);
  return Number.isFinite(num) ? `$${num.toLocaleString()}` : fallback;
};

/**
 * Convierte un valor a número seguro
 * @param {any} val - Valor a convertir
 * @param {number} defaultValue - Valor por defecto si la conversión falla (default: 0)
 * @returns {number} Número válido
 */
export const toNumber = (val, defaultValue = 0) => {
  const n = Number(val);
  return Number.isFinite(n) ? n : defaultValue;
};

/**
 * Capitaliza la primera letra de cada palabra
 * @param {string} texto - Texto a capitalizar
 * @returns {string} Texto capitalizado
 */
export const capitalizarPalabras = (texto) => {
  if (!texto || typeof texto !== 'string') return '';
  return texto
    .trim()
    .split(/\s+/)
    .map(p => p.charAt(0).toUpperCase() + p.slice(1).toLowerCase())
    .join(' ');
};

/**
 * Genera el título de un producto basado en modelo, material y color
 * @param {Object} producto - Objeto producto
 * @returns {string} Título generado
 */
export const generarTituloProducto = (producto) => {
  const { modelo, material, color, nombre } = producto;
  const partes = [];
  
  if (modelo && modelo.trim() !== '') partes.push(modelo.trim());
  if (material && material.trim() !== '') partes.push(material.trim());
  if (color && color.trim() !== '') partes.push(color.trim());
  
  if (partes.length === 0) {
    return capitalizarPalabras(nombre || 'Producto sin título');
  }
  
  return partes.map(parte => capitalizarPalabras(parte)).join(' ');
};

/**
 * Normaliza un string para búsquedas (lowercase y trim)
 * @param {string} str - String a normalizar
 * @returns {string} String normalizado
 */
export const normalizeString = (str) => {
  return (str || '').toString().toLowerCase().trim();
};

